import { useSelector } from "react-redux";

import Breadcrumbs from "~/components/common/breadcrumbs";
import ProductBody from "~/components/pages/product/body";
import { SiteTypes } from "~/redux/reducers/paramsReducer";

import BaltexProductBody from "../../baltex/product/body";
import LandingsProductBody from "../../landings/product/body";
import styles from "./index.module.scss";

export default function ProductPage() {
  const { siteType } = useSelector((state: any) => state.params);
  return (
    <div>
      <div className="container">
        <Breadcrumbs />
      </div>
      <div className={styles.Product}>
        {siteType === SiteTypes.Baltex && <BaltexProductBody />}
        {siteType === SiteTypes.Farkop && <ProductBody />}
        {siteType === SiteTypes.Landing && <LandingsProductBody />}
      </div>
    </div>
  );
}
